import { TmrBaseResource } from 'stylewhere/api'

export class RfidAntennas extends TmrBaseResource {
  static endpoint = 'api/v1/rfidAntennas' //edge
}
